import type { StyleLayer } from './utils/types'

export const layers_radinfra_campaign: StyleLayer[] = [
  {
    id: 'mapillary_presence_border',
    type: 'line',
    filter: ['has', 'mapillary_coverage'],
    minzoom: 12,
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#050dff',
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0.6,
        12,
        0.6,
        14,
        0.9,
        16,
        0.9,
        22,
        0.2,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 0, 10, 6, 10, 16, 8, 18, 20, 22, 24],
    },
  },
  {
    id: 'campaign-line',
    type: 'line',
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fda5e4',
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0.6,
        12,
        0.6,
        14,
        0.9,
        16,
        0.9,
        22,
        0.2,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 0, 7, 6, 7, 16, 4, 18, 14, 22, 16],
    },
  },
  {
    id: 'mapillary_presence_line',
    type: 'line',
    filter: ['has', 'mapillary_coverage'],
    maxzoom: 12,
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#050dff',
      'line-width': ['interpolate', ['linear'], ['zoom'], 0, 0.5, 6, 0.5, 12, 1],
    },
  },
]
